import { render, staticRenderFns } from "./SegmentMenu.vue?vue&type=template&id=60fa27f1&scoped=true"
import script from "./SegmentMenu.vue?vue&type=script&lang=js"
export * from "./SegmentMenu.vue?vue&type=script&lang=js"
import style0 from "./SegmentMenu.vue?vue&type=style&index=0&id=60fa27f1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa27f1",
  null
  
)

export default component.exports